// extracted by mini-css-extract-plugin
export var desktopImage = "pageHeaderImagesSection-module--desktopImage--24e79";
export var directMailImage = "pageHeaderImagesSection-module--directMailImage--a28e1";
export var featurePageImageContainer = "pageHeaderImagesSection-module--featurePageImageContainer--5e73b";
export var imageContainer = "pageHeaderImagesSection-module--imageContainer--2f3ba";
export var landingContainer = "pageHeaderImagesSection-module--landingContainer--c5bd3";
export var mobileImage = "pageHeaderImagesSection-module--mobileImage--a01a6";
export var paymentsPage = "pageHeaderImagesSection-module--paymentsPage--2b758";
export var usesMobileImage = "pageHeaderImagesSection-module--usesMobileImage--63a04";